import React from 'react';

const DashboardIndex = () => {
  const otpVerificationField = localStorage.getItem("otpverificationData");

  return (
    <div className="product-container">
      <div className="container">
        <div className="px-3 py-3">
          <h2 className="text-3xl font-bold mb-0 mb-md-3">Welcome Back!</h2>

          {/* Center horizontally */}
          {otpVerificationField === "true" && (
            <div className="flex justify-center">
              <p className="text-red-600 text-lg subtle-move font-medium text-center">
                Please Contact CBC to Purchase the Device
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardIndex;
